const faqLists = document.querySelectorAll('[data-faq-list]');
const RESIZE_DEBOUNCE_MS = 150;

function measureNaturalHeights(list) {
    const items = Array.from(list.querySelectorAll('.faq-item'));
    const priorHeights = items.map((item) => item.style.height);

    items.forEach((item) => {
        item.style.height = '';
    });

    const heights = items.map((item) => item.offsetHeight);

    items.forEach((item, i) => {
        item.style.height = priorHeights[i];
    });

    return { items, heights };
}

function freezeHeights(list) {
    const { items, heights } = measureNaturalHeights(list);
    let total = 0;

    items.forEach((item, i) => {
        item.dataset.naturalHeight = heights[i];
        item.style.height = `${heights[i]}px`;
        total += heights[i];
    });

    list.dataset.totalHeight = total;
}

function setActiveImage(list, index) {
    const section = list.closest('.faqs-section');
    const panels = section.querySelectorAll('[data-faq-panel]');
    // FAQs without an image or video have no panel, so fall back to the default.
    const hasPanel = Array.from(panels).some((panel) => panel.dataset.faqPanel === index);
    const target = index && hasPanel ? index : 'default';

    panels.forEach((panel) => {
        panel.classList.toggle('active', panel.dataset.faqPanel === target);
    });
}

function setActive(list, activeItem) {
    const total = Number(list.dataset.totalHeight);

    list.querySelectorAll('.faq-item').forEach((item) => {
        const isActive = item === activeItem;
        item.classList.toggle('active', isActive);
        item.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', String(isActive));

        if (activeItem) {
            item.style.height = isActive ? `${total}px` : '0px';
        } else {
            item.style.height = `${item.dataset.naturalHeight}px`;
        }
    });

    list.classList.toggle('has-active', Boolean(activeItem));
    setActiveImage(list, activeItem ? activeItem.dataset.faqItem : null);
}

faqLists.forEach((list) => {
    freezeHeights(list);

    list.querySelectorAll('[data-faq-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const item = trigger.closest('[data-faq-item]');
            setActive(list, item.classList.contains('active') ? null : item);
        });
    });
});

let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        faqLists.forEach((list) => {
            if (!list.classList.contains('has-active')) {
                freezeHeights(list);
            }
        });
    }, RESIZE_DEBOUNCE_MS);
});

function isVideoTriggerClick(list, target) {
    const trigger = target.closest('.faq-video-trigger');
    if (!trigger) return false;
    const section = list.closest('.faqs-section');
    return Boolean(section && section.contains(trigger));
}

function isVideoModalClick(target) {
    return Boolean(target.closest('.oi-video-modal') || target.closest('.modal-backdrop'));
}

document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (isVideoModalClick(target)) return;

    faqLists.forEach((list) => {
        if (!list.classList.contains('has-active')) return;
        if (list.contains(target)) return;
        if (isVideoTriggerClick(list, target)) return;
        setActive(list, null);
    });
});

window.addEventListener('load', () => {
    document.querySelectorAll('.faqs-section .oi-video-modal').forEach((modal) => {
        modal.addEventListener('shown.bs.modal', () => {
            const iframe = modal.querySelector('iframe');
            if (!iframe || !window.oi) return;
            const loaded = /** @type {any} */ (oi.loaded && oi.loaded.video[iframe.id]);
            if (loaded && loaded.is_mounted) {
                loaded.play();
            } else if (oi.video) {
                oi.video.mount(iframe);
            }
        });
    });
});
